import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { ActivatedRoute, RouterLinkActive, RouterLink, RouterOutlet } from '@angular/router';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';

@Component({
  selector: 'app-my-absences',
  templateUrl: './my-absences.component.html',
  styleUrls: ['./my-absences.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatTabNav, MatTabLink, RouterLinkActive, RouterLink, MatTabNavPanel, RouterOutlet],
})
export class MyAbsencesComponent implements OnInit {
  protected activatedRoute = inject(ActivatedRoute);

  navLinks: any[] = [
    {
      label: 'Mis vacaciones',
      link: './my-vacations',
      index: 0,
    },
    {
      label: 'Festivos locales',
      link: './local-holidays',
      index: 1,
    },
    {
      label: 'Bajas y permisos',
      link: './my-absence-requests',
      index: 2,
    },
  ];

  queryParams: any = {};

  ngOnInit(): void {
    this.listenQueryParams();
  }

  private listenQueryParams() {
    this.activatedRoute.queryParamMap.subscribe((data: any) => {
      const params = data.params;
      this.queryParams = params;
    });
  }
}
